import {createContext} from 'react';

const experienciasContext = createContext();

export default experienciasContext;